import { AccountRole } from '../types/account-role';

export function formatDate(dateString: Date | string,
  dateStyle?: 'full' | 'long' | 'medium' | 'short',
  timeStyle?: 'full' | 'long' | 'medium' | 'short',) {
  return new Date(dateString).toLocaleString('fa-IR', { dateStyle, timeStyle })
}

export function formatRole(role: AccountRole) {
  switch (role) {
  case AccountRole.ADMIN:
    return 'ادمین'
  case AccountRole.NORMAL:
    return 'ساده'
  }

}

export function formatPhoneNumber(phoneNumber: string) {
  return Number(phoneNumber.substring(3, 13)).toLocaleString('fa-IR', { useGrouping: false })
}